<template>
  <div ref="chart" style="width: 100%; height: 300px"></div>
</template>

<script>
import { GoogleCharts } from "google-charts";
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";

export default {
  name: "PieChart",
  components: {
    // GoogleCharts,
  },
  props: {
    text: {
      type: String,
      default: "hello world",
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    GoogleCharts.load(() => {
      const data = GoogleCharts.api.visualization.arrayToDataTable(this.data);

      const options = {
        curveType: "function",
        legend: { position: "bottom" },
        colors: ["#721cff", "#CCADFF"],
        pieHole: 0.4,
        backgroundColor: { fill: "transparent" },
      };

      const chart = new GoogleCharts.api.visualization.PieChart(
        this.$refs.chart
      );
      chart.draw(data, options);
    });
  },
  methods: {},
  setup() {
    return {};
  },
  data() {
    return {};
  },
};
</script>

<style></style>
